import React, { Component } from 'react';
import Rx from 'rxjs';

class Timer extends Component {
    constructor(props) {        
        super(props);        
        this.state = {timeElapsed:0.0, shouldTimerRun:false};
        this.toggleTimer = this.toggleTimer.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.updateDisplay = this.updateDisplay.bind(this);
    }
    toggleTimer(){
        this.setState({
            shouldTimerRun : !this.state.shouldTimerRun
        });
    }    

    componentDidUpdate(prevProps, prevState){

        if(prevState.shouldTimerRun !== this.state.shouldTimerRun)
        {
            if(this.state.shouldTimerRun)
            {
                const tickUpdate = this.props.tickUpdate ? this.props.tickUpdate : function(x){};
                const timerCompleted = this.props.timerCompleted ? this.props.timerCompleted : function(){};
                this.startTimer(this.props.totalTimeSeconds*1000, tickUpdate, timerCompleted);
                if(this.props.timerStarted){
                    this.props.timerStarted();
                }
            }                        
        }       
    }

    updateDisplay(value, tickUpdate){ 
        const timeElapsed = this.state.timeElapsed + value.interval;                       
        this.setState({
            timeElapsed : timeElapsed
        });
        tickUpdate(timeElapsed);
    }

    startTimer(totalTimeMS, tickUpdate, callback){           
        this.setState( {
            timeElapsed: 0,
            shouldTimerRun : true,     
        }, function(){     
            const source = Rx.Observable
                .interval(1000 /* ms */)
                .timeInterval()
                .takeWhile(()=> this.state.timeElapsed < totalTimeMS && this.state.shouldTimerRun )            
            source.subscribe(                
                (x) => {     
                    this.updateDisplay(x, tickUpdate);                    
                },
                 (err) => {
                     console.log('Error: ' + err);
                },
                () => {
                     this.setState({
                         shouldTimerRun: false
                     }, ()=>{
                            const stopped = this.state.timeElapsed < totalTimeMS;
                            callback(stopped);                            
                     })                     
                }
            );
        });
    }

    stopTimer(){        
        this.setState({
            shouldTimerRun:false
        })
    }
    render(){
        const startStopButtonText = this.state.shouldTimerRun ? "Stop":"Start";
        const rounded = Math.round(this.state.timeElapsed/1000);
        return (
            <div className="row mb-2">
                <div className="col-sm-2"><button className="btn btn-primary" onClick={this.toggleTimer} disabled={this.props.startStopDisabled} >{startStopButtonText}</button></div>
                <div className="col-sm-6"><p>Seconds elapsed: <b>{rounded}</b></p></div>
            </div>
        );
    }
}

export default Timer;


// WEBPACK FOOTER //
// ./src/Timer.js